import { VscLoading } from 'react-icons/vsc';

export const LoadingOverlay = () => {
  return (
    <div className="w-full h-full fixed top-0 left-0 bottom-0 right-0 z-50 bg-neutral-100 flex justify-center items-center text-primary-500">
      <VscLoading className="animate-spin" size={40} />
    </div>
  );
};
